<template>
  <div class="viewport viewport-with-top-nav viewport-compact align-items-center justify-content-center">
    <top-nav></top-nav>
    <otp @otp-success="onOtpSuccess" :pin="pin" v-if="pin"></otp>
    <div class="small text-muted-more text-center mt-5 px-5">
      {{$t('LoginOtpPage.phoneNumberNotValidPleaseVisit')}}
      <router-link :to="{name: 'branches'}">{{$t('LoginOtpPage.anyOfOurBranches')}}</router-link>
    </div>
  </div>
</template>

<script>
import Otp from '@shared/components/Otp'
import store from '@shared/store'
import TopNav from '@shared/components/TopNav'
import UserMixin from '@shared/mixins/UserMixin'
import AnalyticsMixin from '@shared/mixins/AnalyticsMixin'

export default {
      components: { TopNav, Otp },
      mixins: [UserMixin, AnalyticsMixin],
      data() {
        return {
          pin: store.state.userPinForOTP
        }
      },
      async created() {
        if (!this.pin) {
          await this.$router.replace({ name: 'home' })
        }
      },
      methods: {
        onOtpSuccess() {
          this.logUserSignedIn(this.pin)
          this.getAndStoreCustomerProfile(this.pin)
              .then(() => {
                store.clearUserPinForOTP()
                this.redirectToCustomerOverview(this.pin)
              })
        }
    }
  }
</script>
